import { render, staticRenderFns } from "./buy-protocol.vue?vue&type=template&id=88f09754&scoped=true"
import script from "./buy-protocol.vue?vue&type=script&lang=js"
export * from "./buy-protocol.vue?vue&type=script&lang=js"
import style0 from "./buy-protocol.vue?vue&type=style&index=0&id=88f09754&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88f09754",
  null
  
)

export default component.exports